const studentFullname = student => {
  if (!student) return null

  return `${student.forename || ""} ${student.surname || ""}`.replace(/  +/g, " ").trim()
}

export default studentFullname
